<!-- Center canvas: typed into directly (read-only in View/Proof/Annotate) -->
<div class="cr-sub-card" *ngIf="isPreview">
  <span
    class="cr-sub-value"
    [appInlineEdit]="block.variables?.Preheader ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert preheader text here"
    (inlineEditChange)="onChange($event)"
  ></span>
  <span class="cr-sub-badge">Preheader</span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-sub-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.Preheader ?? ''"
    (handleOnChange)="onChange($event)"
    [placeholder]="preheaderPlaceholder"
    [maxLength]="500"
    variable="Preheader"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
